import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography, TextField, Paper } from '@material-ui/core';
import { toast } from 'react-toastify';
import apiService from '../../services.js/apiService';
import Colours from '../../styles/colours';
import Loading from '../../components/global/OverLoading';

const BusinessProfile = (props) => {
  const [loading, setLoading] = useState(true);
  const [businessProfile, setBusinessProfile] = useState({
    id:            '',
    name:          '',
    regNo:         '',
    address:       '',
    contactEmail:  '',
    contactPerson: '',
    contactNo:     '',
  });

  const getBusinessProfile = async () => {
    try {
      const data = await apiService.getBusinessProfile(props.pageId);
      setBusinessProfile(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getBusinessProfile();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="container px-0">
        <div className="row">
          <div className="col-md-8">
            <Typography
              className="mt-3 font-weight-bold"
              variant="body1"
            >
              {`ID : ${businessProfile.id}`}
            </Typography>

            <form>
              {/* <Typography className="mt-2 ml-0" variant="caption" color="inherit" style={{ color: 'red' }}>*required</Typography> */}
              <Paper className="d-flex flex-column mt-2 pb-5 px-4" elevation={1}>
                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>Name</Typography>
                  <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>{businessProfile.name}</Typography>
                </div>

                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>ACRA Registration No.</Typography>
                  <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>{businessProfile.regNo}</Typography>
                </div>

                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>
                    Address
                    {' '}
                    <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    className="mt-2 block"
                    name="address"
                    type="text"
                    value={businessProfile.address}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>
                    Contact Email
                    {' '}
                    <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    className="mt-2 block"
                    name="contactEmail"
                    type="email"
                    value={businessProfile.contactEmail}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>
                    Contact Person
                    {' '}
                    <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    className="mt-2 block"
                    name="contactPerson"
                    type="text"
                    value={businessProfile.contactPerson}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div className="mt-4">
                  <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>
                    Contact Phone Number
                    {' '}
                    <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    className="mt-2 block"
                    name="contactNo"
                    type="text"
                    value={businessProfile.contactNo}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>
              </Paper>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

BusinessProfile.propTypes = {
  pageId: PropTypes.number.isRequired,
};

export default connect(null, null)(BusinessProfile);
